export const CHANGE_LANGUAGE = 'change_language';
export const CHANGE_CURRENCY = 'change_currency';
export const LINK_ACTIVE = "link_active";
export const CHANGE_THEME = 'change_theme';

